import { createSlice } from '@reduxjs/toolkit';
import { createEventObject, createCourseObject, createLearningPathObject, createInPersonEventObject } from '../utility/utils.js';

export const resources = createSlice({
  name: 'adoberesources',
  initialState: {
    selectedTags: [],
    catalogData: [],
    registerPageSelectedTopics: [],
    allEventsWithTimeZone: null,
    allIPEventsWithTimeZone: [],
    allCourses: null,
    // allQuickTips: [],
    eventCategoryPageFilters: [],
    courseCategoryPageFilters: [],
    quickTipCategoryPageFilters: [],
    combinedQuickTips: null,
    allNotifications: null,
    recommendedCourses:[],
    learningPaths: null,
    allPastEvents:[],
    allPastIpEvents:[],
    rawPastData: null
  },

  reducers: {
    updateSelectedTags: (state, action) => {
      state.selectedTags = action.payload;
    },
    updateCatalogData: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateCatalogData]`, action || []);
        let removeVBGEvent= action.payload.allEvents?.filter((ele)=>!(Array.isArray(ele.tags) && ele.tags.some(tag=>tag.split(" ").join("").toLowerCase()==="vbgexclusive")))
        let allEvents = removeVBGEvent;
        let allCourses = action.payload.allCourses;
        let learningPaths = action.payload.learningPaths;
        let allIPEvents = action.payload.allIPEvents;
        // let allPastEvents = action.payload.allPastEvents;
        let allCoursesForState = [];
        let allEventsForState = [];
        let allLearningPaths = [];
        let allIPEventsWithTimeZone = [];
        // let allPastEventsForState = [];
        // let allPastIPEventsForState = [];
        let userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
        allEvents.forEach((event) => {
          allEventsForState.push(createEventObject(event, userLanguage));
        });
        allIPEvents?.forEach((event) => {
          allIPEventsWithTimeZone.push(createInPersonEventObject(event, userLanguage));
        });
        allCourses.forEach((course) => {
          allCoursesForState.push(createCourseObject(course, userLanguage));
        });
        learningPaths.forEach((learningPath) => {
          allLearningPaths.push(createLearningPathObject(learningPath, userLanguage));
        });
//           allPastEvents.forEach((event) => {  
//             if(event?.format === "Classroom" ){
// allPastIPEventsForState.push(createInPersonEventObject(event,userLanguage))
//             }
//             else {
// allPastEventsForState.push(createEventObject(event, userLanguage));
//             }
//         });
        
        state.allCourses = allCoursesForState;
        state.allEvents = allEventsForState;
        state.allEventsWithTimeZone = allEventsForState;
        state.allIPEventsWithTimeZone = allIPEventsWithTimeZone;
        state.learningPaths = allLearningPaths;
        state.catalogData = allEvents.concat(allCourses);
        state.learningPaths = allLearningPaths;
        // state.allPastEvents = allPastEventsForState;
        // state.allPastIpEvents = allPastIPEventsForState;
      }
    },
    updatePastEvents: (state, action) => {
      if (action.payload) {
        let allPastEvents = action.payload;
        let allPastEventsForState = [];
        let allPastIPEventsForState = [];
        let userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
        Object.values(allPastEvents)?.forEach((event) => {
          if (event?.format === "Classroom") {
            allPastIPEventsForState.push(createInPersonEventObject(event, userLanguage))
          }
          else {
            allPastEventsForState.push(createEventObject(event, userLanguage));
          }
        });
        state.allPastEvents = allPastEventsForState;
        state.allPastIpEvents = allPastIPEventsForState;
        state.rawPastData = allPastEvents;
      }
    },
    updateRegisterPageSelectedTopics: (state, action) => {
      console.log(action);
      state.registerPageSelectedTopics = action.payload;
    },
    // updateQuickTips: (state, action) => {
    //   if(action.payload) {
    //     console.log(`[REDUCER] [updateCatalogData]`, action || []);
    //     state.allQuickTips = {
    //       combinedQuickTips: action.payload.combinedQuickTips,
    //       additionalData: action.payload.additionalData
    //     }
    //     // state.allQuickTips = action.payload
    //   }
    // },
    updateQuickTipCategoryFilterData: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateQuickTipCategoryFilterData]`, action || []);
        state.quickTipCategoryPageFilters = action.payload
      }
    },
    updateEventsCategoryFilterData: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateEventsCategoryFilterData]`, action || []);
        state.eventCategoryPageFilters = action.payload
      }
    },
    updateCoursesCategoryFilterData: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateCoursesCategoryFilterData]`, action || []);
        state.courseCategoryPageFilters = action.payload
      }
    },
    updateNotifications: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateNotifications]`, action || []);
        state.allNotifications = action.payload;
      }
    },
    updateRecommendedCourses: (state, action) => {
      if(action.payload) {
        console.log(`[REDUCER] [updateRecommendedCourses]`, action || []);
        state.recommendedCourses = action.payload;
      }
    },
  },
});

export const {
  updateSelectedTags,
  updateCatalogData,
  updatePastEvents,
  updateRegisterPageSelectedTopics,
  updateQuickTipCategoryFilterData,
  updateEventsCategoryFilterData,
  updateCoursesCategoryFilterData,
  updateNotifications,
  updateRecommendedCourses
} = resources.actions;

export default resources.reducer;
